import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-blog-sanificazioni-vs-igienizzazioni',
  imports: [CommonModule],
  templateUrl: './blog-sanificazioni-vs-igienizzazioni.html',
  styleUrls: ['./blog-sanificazioni-vs-igienizzazioni.scss'],
})
export class BlogSanificazioniVsIgienizzazioniComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Sanificazioni vs Igienizzazioni: cosa cambia davvero? | SAMI Pulizie',
      description:
        'Sanificazione e igienizzazione non sono la stessa cosa: scopri differenze, quando servono e quale scegliere a Pescara per casa, ufficio o attività.',
      keywords:
        'sanificazione Pescara, igienizzazione Pescara, differenza sanificazione igienizzazione, pulizie professionali Pescara, SAMI Pulizie',
      canonicalUrl: '/blog/sanificazioni-vs-igienizzazioni-cosa-cambia',

      ogTitle: 'Sanificazioni vs Igienizzazioni: cosa cambia davvero?',
      ogDescription:
        'Scopri differenze, utilizzi e consigli pratici per scegliere tra sanificazione e igienizzazione.',
      ogImage: '/assets/og-sami.jpg',
      ogType: 'article',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: 'Sanificazioni vs Igienizzazioni: cosa cambia davvero?',
        datePublished: '2025-03-03',
        dateModified: '2025-03-03',
        author: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/'
        },
        publisher: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://samipulizie.it/assets/logo.png'
          }
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://samipulizie.it/blog/sanificazioni-vs-igienizzazioni-cosa-cambia'
        }
      }
    });
  }

  navigateToPreventivo() {
    this.router.navigateByUrl('/preventivo');
  }
}
